<template>
  <v-row justify="center">
    <v-dialog v-model="active" persistent scrollable max-width="500">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Seleccione el agente
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true }
            }"
          >
            <v-card-text style="max-height: 350px">
              <v-form>
                <v-row dense justify="center">
                  <!-- Agentes -->
                  <v-col cols="12">
                    <v-select
                      v-model="searchData.agent"
                      prepend-inner-icon="mdi-account"
                      required
                      filled
                      rounded
                      dense
                      clearable
                      class="rounded-small"
                      item-text="name"
                      item-value="id"
                      :items="agentList"
                      label="Agentes"
                    ></v-select>
                  </v-col>

                  <v-col cols="12">
                    <!-- <p class="grey--text caption pb-3">
                                            <v-icon small left color="blue-grey"
                                                >mdi-information</v-icon
                                            >Seleccione un rango de fecha para
                                            la búsqueda.
                                        </p> -->

                    <v-menu
                      ref="dateRangeMenu"
                      v-model="dateRangeMenu"
                      :close-on-content-click="false"
                      :return-value.sync="dates"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dates"
                          required
                          filled
                          rounded
                          class="rounded-small"
                          label="Rango de fecha"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        locale="es-us"
                        v-model="dates"
                        :max="new Date().toISOString().substr(0, 10)"
                        range
                        scrollable
                        no-title
                      >
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="dateRangeMenu = false"
                            >Cancelar</v-btn
                          >
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            rounded
                            :loading="isLoading"
                            :disabled="isLoading"
                            color="success"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click="$refs.dateRangeMenu.save(dates)"
                            >ok</v-btn
                          >
                        </v-hover>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <!-- <v-hover v-slot:default="{ hover }"> -->
            <!-- <v-btn
                                v-show="date"
                                text
                                rounded
                                class="mr-1"
                                v-if="module === 'productivityReport'"
                                :color="hover ? 'secondary' : 'grey'"
                                @click="downloadTodayCsv()"
                            >
                                Exportar CSV
                            </v-btn> -->
            <v-btn
              color="success"
              @click="downloadTodayCsv()"
              small
              rounded
              fab
            >
              <v-icon>
                mdi-download
              </v-icon>
            </v-btn>
            <!-- </v-hover> -->
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="closedialog('close')"
                >Cancelar</v-btn
              >
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="isLoading"
                :disabled="isLoading || date == ''"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="passes(closedialog)"
                >Buscar</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import moment from "moment";
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";
import CdrDownloadToCsv from "@/components/Utils/CdrDownloadCsv";

// import axios from "axios";
// import CdrDownloadToCsv from "@/components/Utils/CdrDownloadCsv";
// import { mapState } from "vuex";

export default {
  name: "AgentPickerDialog",

  props: {
    active: Boolean,
    date: {
      type: String,
      required: false
    },
    searchType: {
      type: String
    },
    module: {
      type: String
    }
  },

  components: {
    vuescroll
  },

  data() {
    return {
      isLoading: false,
      dialog: false,
      agentList: [],
      searchData: [{ agent: null }],
      dateRangeMenu: false,
      dates: [
        new Date().toISOString().substr(0, 10),
        new Date().toISOString().substr(0, 10)
      ]

      // date: ""
    };
  },

  computed: {
    minDate() {
      let dayLimit = new moment().subtract(1, "day").format("YYYY-MM-DD");

      return dayLimit;
    }
  },

  created() {
    this.getAgents();
  },

  methods: {
    closedialog(value = null) {
      const params = {
        user_id: this.searchData.agent,
        date: this.dates[0],
        dateEnd: this.dates[1]
      };

      this.$emit("dialog:change", value, params);

      // this.date = "";
    },

    async getAgents() {
      try {
        const { data } = await PbxHttpClient.get("/clients/show/agents_select");
        this.agentList = data.data;
      } catch (err) {
        console.log(err);
      }
    },

    async downloadTodayCsv() {
      let payload = {
        date: this.dates[0],
        dateEnd: this.dates[1],
        user_id: this.searchData.agent
      };

      try {
        await CdrDownloadToCsv(payload, this.module);
      } catch (err) {
        // console.log(err);
        this.$snotify.error(
          "No se pudo descargar los registros seleccionados.",
          "¡Error!"
        );
      }
    }
  }
};
</script>
